module.exports = __webpack_public_path__ + "img/ancient_apparition.99d558f4.png";